// Makes Ritual slideshow arrows always usable + adds wrap-around paging
document.addEventListener('DOMContentLoaded', () => {
  const init = () => {
    document.querySelectorAll('slideshow-component').forEach((slideshow) => {
      const scroller = slideshow.querySelector('[ref="scroller"]');
      const prevBtn = slideshow.querySelector('[ref="previous"]');
      const nextBtn = slideshow.querySelector('[ref="next"]');

      if (!scroller || !prevBtn || !nextBtn) return;

      // Always enable arrows (disabled buttons don't click, even with CSS)
      const enableArrows = () => {
        prevBtn.removeAttribute('disabled');
        nextBtn.removeAttribute('disabled');
        prevBtn.setAttribute('aria-disabled', 'false');
        nextBtn.setAttribute('aria-disabled', 'false');
      };

      enableArrows();

      // Keep enabling them in case the theme re-disables after scroll
      const mo = new MutationObserver(enableArrows);
      mo.observe(prevBtn, { attributes: true, attributeFilter: ['disabled'] });
      mo.observe(nextBtn, { attributes: true, attributeFilter: ['disabled'] });

      const getMaxScroll = () => scroller.scrollWidth - scroller.clientWidth;
      const atStart = () => scroller.scrollLeft <= 5;
      const atEnd = () => scroller.scrollLeft >= getMaxScroll() - 5;

      // This carousel moves by "pages" (visible width), not slide-by-slide
      const pageAmount = () => scroller.clientWidth;

      const goTo = (left) => scroller.scrollTo({ left, behavior: 'smooth' });

      const handlePrev = (e) => {
        // Prevent Ritual's internal handler so we fully control behaviour
        e.preventDefault();
        e.stopImmediatePropagation();

        if (atStart()) {
          goTo(getMaxScroll());
        } else {
          goTo(Math.max(0, scroller.scrollLeft - pageAmount()));
        }
      };

      const handleNext = (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        if (atEnd()) {
          goTo(0);
        } else {
          goTo(Math.min(getMaxScroll(), scroller.scrollLeft + pageAmount()));
        }
      };

      // Use capture so we beat the theme’s click handler
      prevBtn.addEventListener('click', handlePrev, true);
      nextBtn.addEventListener('click', handleNext, true);
    });
  };

  // Run once now…
  init();

  // …and again after Shopify section reloads (theme editor / AJAX renders)
  document.addEventListener('shopify:section:load', init);
});